<template>
    <div id="testwrap">

        <div class="box">
            <select v-model="join">
                <option v-for="(url,idx) in joins" :key="idx">
                    {{ url }}
                </option>
            </select>

            <div style="margin-bottom:20px;"></div>

            <iframe style="width:100%; height:100%;" :src="`${$store.state.dir}${join}`"></iframe>
        </div>

        <div  class="box">
            <select v-model="vehicle" >
                <option v-for="(url,idx) in vehicles" :key="idx">
                    {{ url }}
                </option>
            </select>

            <div style="margin-bottom:20px;"></div>

            <iframe style="width:100%; height:100%;" :src="`${$store.state.dir}${vehicle}`"></iframe>
        </div>

        <div  class="box">
            <select v-model="sc" >
                <option v-for="(url,idx) in scs" :key="idx">
                    {{ url }}
                </option>
            </select>

            <div style="margin-bottom:20px;"></div>

            <iframe style="width:100%; height:100%;" :src="`${$store.state.dir}${sc}`"></iframe>
        </div>

        <div  class="box">
            <select v-model="booking" >
                <option v-for="(url,idx) in bookings" :key="idx">
                    {{ url }}
                </option>
            </select>

            <div style="margin-bottom:20px;"></div>

            <iframe style="width:100%; height:100%;" :src="`${$store.state.dir}${booking}`"></iframe>
        </div>
    </div>
</template>

<script>
    export default {
        name:'test',
        data() {
            return {

                join:'Publishing/index.html',
                vehicle:'Publishing/브랜드선택 모델목록.html',
                sc:'Publishing/SC-1.SC매칭 정보입력.html',
                booking:'Publishing/BK-1.추천매칭기본정보입력.html',
                dir:'Publishing/',                
            }
        },
        computed: {
            joins() {
                return [
                    this.dir+'index.html',
                    this.dir+'login.html', 

                    this.dir+'회원가입.html',
                    this.dir+'회원가입 휴대폰인증.html',
                    this.dir+'약관동의.html',
                    this.dir+'소셜계정등록.html',
                    this.dir+'회원가입완료.html',

                    this.dir+'비밀번호 설정.html',
                    this.dir+'비밀번호 재설정.html',
                    this.dir+'비밀번호찾기_휴대폰인증_.html',                    
                ]
            },

            vehicles() {
                return [
                    this.dir+'브랜드선택 모델목록.html',
                    this.dir+'CA-1.브랜드선택.html',
                    this.dir+'CA-2.모델목록.html',
                    this.dir+'CA-3.차량정보.html',
                    this.dir+'CA-4.차량후기리스트.html',

                    this.dir+'ME-0.메뉴.html',
                    this.dir+'ME-1.계정정보.html',
                    this.dir+'ME-2-1.내가남긴후기_SC copy.html',
                    this.dir+'ME-2-1.내가남긴후기_SC.html',
                    this.dir+'ME-2-2.내가남긴후기-전시장.html',
                    this.dir+'ME-2-3.내가남긴후기-전시장-차량.html',
                    this.dir+'ME-3-1.딜러사 둘러보기.html',
                    this.dir+'ME-3-1-1.딜러사 둘러보기.html',
                    this.dir+'ME-3-1-2.딜러사 둘러보기.html',
                    this.dir+'ME-4.파트너스 컨텐츠.html',
                    this.dir+'ME-5-1.공지사항리스트.html',
                    this.dir+'ME-5-2.공지사항뷰.html',
                    this.dir+'ME-6-1.자주묻는질문리스트.html',
                    this.dir+'ME-6-2.자주묻는질문뷰.html',
                    this.dir+'ME-7-1.1대1문의리스트.html',
                    this.dir+'ME-7-2.1대1문의폼.html',
                    this.dir+'ME-7-3.1대1문의뷰.html',
                ]
            },

            scs() {
                return [
                    this.dir+'SC-1.SC매칭 정보입력.html',
                    this.dir+'SC-2.SC매칭 결과화면.html',
                    this.dir+'SC-3.SC주변 모두보기.html',
                    this.dir+'SC-4.SC상세페이지.html',
                    this.dir+'SC-5.SC후기리스트.html',
                    this.dir+'SH-1.전시장상세페이지.html',
                    this.dir+'SH-2.전시장후기리스트.html',
                    this.dir+'SH-3.소속컨설턴트.html',
                    this.dir+'SH-4.딜러사 상세페이지.html',
                    this.dir+'SH-5.전시장리스트.html',
                ]
            },

            bookings() {
                return [
                    this.dir+'BK-1.추천매칭기본정보입력.html',
                    this.dir+'BK-2.추천매칭세부요소입력.html',
                    this.dir+'BK-3.방문일정입력.html',
                    this.dir+'BK-4.추천매칭결과.html',
                    this.dir+'BK-5.예약자정보입력.html',
                    this.dir+'BK-6.컨설턴트직접찾기.html',
                    this.dir+'BL-1.예약내역 리스트.html',
                    this.dir+'BL-2-1.예약내역 상세(확정대기).html',
                    this.dir+'BL-2-2.예약내역 상세(확정완료).html',
                    this.dir+'BL-2-3.예약내역 상세(변경).html',
                    this.dir+'BL-3.방문완료 리스트.html',
                    this.dir+'RV-1-1.컨설턴트후기입력.html',
                    this.dir+'RV-1-2.전시장후기입력.html',
                    this.dir+'RV-1-3.차량후기입력.html',
                ]
            }
        },
    }
</script>

<style lang="css" scoped>
#testwrap{
    width:100%;
    height:100%;
}

.box {
    margin-right: 30px;
    display: inline-block;
    width:375px; 
    height:750px; 
    margin-top:30px;
}
</style>